(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function () {
    const form = document.getElementById("FacetFiltersForm");
    if (!form) return;

    let debounceTimer;
    form.addEventListener("change", function () {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(() => form.submit(), 300);
    });

    const filtersTrigger = document.querySelector(".filters-trigger");
    const filtersPanel = document.querySelector(".collection__sidebar__filters");

    if (filtersTrigger && filtersPanel) {
      filtersTrigger.addEventListener("click", function () {
        filtersPanel.classList.toggle("collection__sidebar__filters--active");
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
    const navigationHeaders = document.querySelectorAll('.footer__navigation__header');

    navigationHeaders.forEach(header => {
        header.setAttribute('role', 'button');
        header.setAttribute('tabindex', '0');
        header.setAttribute('aria-expanded', 'false');

        function toggle() {
            const navigation = header.parentElement;
            const isOpen = navigation.classList.toggle('footer__navigation--open');
            header.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
        }

        header.addEventListener('click', toggle);
        header.addEventListener('keydown', function(e) {
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                toggle();
            }
        });
    });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["golf-holes"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll(".golf-holes__carousel").forEach(carousel => {
      const cards = carousel.querySelectorAll(".golf-holes__card");
      const switches = carousel.querySelectorAll(".golf-holes__switch");
      const total = cards.length;
      let current = 0;

      function goTo(index) {
        if (index < 0 || index >= total) return;
        cards[current].classList.remove("golf-holes__card--active");
        current = index;
        cards[current].classList.add("golf-holes__card--active");
        updateNav();
      }

      function updateNav() {
        switches.forEach((sw, i) => {
          sw.classList.toggle("golf-holes__switch--active", i === current);
        });
        cards.forEach(card => {
          const prev = card.querySelector("[data-dir='prev']");
          const next = card.querySelector("[data-dir='next']");
          if (prev) prev.disabled = (current === 0);
          if (next) next.disabled = (current === total - 1);
        });
      }

      carousel.addEventListener("click", function (e) {
        const sw = e.target.closest(".golf-holes__switch");
        if (sw) {
          e.preventDefault();
          goTo(parseInt(sw.dataset.goto, 10));
          return;
        }
        const btn = e.target.closest("[data-dir]");
        if (btn) {
          e.preventDefault();
          if (btn.dataset.dir === "prev") goTo(current - 1);
          if (btn.dataset.dir === "next") goTo(current + 1);
        }
      });

      carousel.addEventListener("keydown", function (e) {
        if (e.key === "ArrowLeft") goTo(current - 1);
        if (e.key === "ArrowRight") goTo(current + 1);
      });

      updateNav();
    });

    // Klik na celou image oblast otevře lightbox
    document.querySelectorAll(".golf-holes__image").forEach(area => {
      area.addEventListener("click", function (e) {
        const img = area.querySelector("[data-lightbox-image]");
        if (img && e.target !== img) {
          img.click();
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
  const stickyHeader = document.querySelector('.sticky-header');
  const header = document.querySelector('.header');
  const topbar = document.querySelector('.header__topbar');

  if (!stickyHeader || !header) return;

  // Measure heights only when NOT stuck (original layout)
  const floatingBar = header.querySelector('.header__floating');
  let measured = false;
  const updateVars = () => {
    if (header.classList.contains('is-stuck')) return;
    document.body.style.setProperty('--header-height', `${stickyHeader.offsetHeight}px`);
    if (floatingBar) {
      document.body.style.setProperty('--floating-height', `${floatingBar.offsetHeight}px`);
    }
    measured = true;
  };
  new ResizeObserver(updateVars).observe(stickyHeader);
  if (floatingBar) new ResizeObserver(updateVars).observe(floatingBar);
  stickyHeader.querySelectorAll('img').forEach(img => {
    if (!img.complete) img.addEventListener('load', updateVars);
  });
  updateVars();

  // Open/close mobile nav
  const hamburgers = document.querySelectorAll('.header__hamburger');
  const closeButton = document.querySelector('.header__close');
  hamburgers.forEach(btn => {
    btn.addEventListener('click', () => header.classList.add('header--open'));
  });
  if (closeButton) {
    closeButton.addEventListener('click', () => header.classList.remove('header--open'));
  }

  // Sticky: when header scrolls out of view, switch to fixed
  if (header.classList.contains('header--sticky')) {
    let headerBottom = 0;
    let isStuck = false;

    const measure = () => {
      // Original position of header bottom (relative to page)
      headerBottom = stickyHeader.offsetTop + stickyHeader.offsetHeight;
    };
    measure();

    const onScroll = () => {
      const shouldStick = window.scrollY > headerBottom + 50;
      if (shouldStick !== isStuck) {
        isStuck = shouldStick;
        header.classList.toggle('is-stuck', isStuck);
        if (topbar) topbar.style.display = isStuck ? 'none' : '';
      }
    };

    window.addEventListener('scroll', () => requestAnimationFrame(onScroll), { passive: true });
    window.addEventListener('resize', measure);
    onScroll();
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-webkamera"] && !Shopify.designMode) return;
  try {
    
(function() {
  var sectionId = '{{ section.id }}';
  var img = document.getElementById('webcam-image-' + sectionId);
  var timestamp = document.getElementById('webcam-timestamp-' + sectionId);
  var baseUrl = img ? img.src.split('?')[0] : '';
  var interval = parseInt('{{ section.settings.refresh_interval }}', 10) || 10;

  function updateTimestamp() {
    if (!timestamp) return;
    var now = new Date();
    var h = String(now.getHours()).padStart(2, '0');
    var m = String(now.getMinutes()).padStart(2, '0');
    var d = String(now.getDate()).padStart(2, '0');
    var mo = String(now.getMonth() + 1).padStart(2, '0');
    var y = now.getFullYear();
    timestamp.textContent = d + '. ' + mo + '. ' + y + ' — ' + h + ':' + m;
  }

  function refreshImage() {
    if (!img) return;
    img.src = baseUrl + '?t=' + Date.now();
    updateTimestamp();
  }

  updateTimestamp();
  setInterval(refreshImage, interval * 60 * 1000);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"] && !Shopify.designMode) return;
  try {
    
  const handleIntersection = (entries, observer) => {
    if (!entries[0].isIntersecting) return;

    observer.unobserve(productRecommendationsSection);

    const url = productRecommendationsSection.dataset.url;

    fetch(url)
      .then(response => response.text())
      .then(text => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('.product-recommendations');

        if (recommendations && recommendations.innerHTML.trim().length) {
          productRecommendationsSection.innerHTML = recommendations.innerHTML;
        }
      })
      .catch(e => {
        console.error(e);
      });
  };

  const productRecommendationsSection = document.querySelector('.product-recommendations');
  const observer = new IntersectionObserver(handleIntersection, {rootMargin: '0px 0px 300px 0px'});

  observer.observe(productRecommendationsSection);

  } catch(e) { console.error(e); }
})();
})();
